// src/modules/app-views/goodsReceipt/pages/Document/modals/InstallmentModal/index.jsx
// *******************************************************************************
// INSTALLMENT MODAL
// *******************************************************************************
// GenericModal (1 step) for adding or editing a payment installment (duplicata).
// Used by PaymentBillingCard in the goods receipt document.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useCallback, useMemo } from 'react';
import { DollarOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import financialService from 'services/financialService';
import Step1 from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InstallmentModal = ({
  show,
  setShow,
  onConfirm,
  editingItem,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleFinish = useCallback(async ({ form }) => {
    const values = form.getFieldsValue(true);

    const installmentData = {
      number: values.number || '',
      dueDate: values.dueDate,
      amount: financialService.roundCurrency(values.amount || 0),
      type: values.type || '',
    };

    onConfirm?.(installmentData);
    return true;
  }, [onConfirm]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const initialValues = useMemo(() => ({
    number: editingItem?.number || '',
    dueDate: editingItem?.dueDate || undefined,
    amount: editingItem?.amount || 0,
    type: editingItem?.type || '15', // Default to boleto
  }), [editingItem]);

  const steps = useMemo(() => [
    {
      stepTitle: 'installment',
      validationFields: ['number', 'dueDate', 'amount'],
      content: () => <Step1 />,
    },
  ], []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      title={editingItem ? 'edit' : 'add_installment'}
      icon={<DollarOutlined />}
      steps={steps}
      onFinish={handleFinish}
      initialValues={initialValues}
      width={560}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InstallmentModal;
